import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationReducers } from '../app.reducers';
import { ApplicationState } from './application.state';

const selectApplicationState = createFeatureSelector<ApplicationState>(ApplicationReducers.TAG);

export const selectActiveLanguage = createSelector(selectApplicationState, (state) => state?.activeLanguage);
